import { render, staticRenderFns } from "./formPermohonan.vue?vue&type=template&id=85da49ee&"
import script from "./formPermohonan.vue?vue&type=script&lang=js&"
export * from "./formPermohonan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports